import { createAdminI18n } from './runtime'
import AdminLanguageSelector from './AdminLanguageSelector.vue'

const groups = require('./catalog-groups')
const catalogs = require.context('./', false, /^\.\/(?!.*(?:-scope|-provenance|source-baseline)).+\.json$/)
const messages = groups.reduce((all, group) => Object.assign(all, catalogs(`./${group}.json`)), {})

export default {
  install(Vue, { onMissing = () => {}, loadFlags = async () => ({}) } = {}) {
    let storage
    try { storage = window.localStorage } catch (_) { /* Optional browser storage. */ }
    // Stay OFF until the backend explicitly enables localization. In particular,
    // localStorage must not translate the first render while flags are loading.
    const admin = createAdminI18n({ messages, storage, onMissing, enabled: false })
    const state = new Vue({ data: { locale: admin.locale, enabled: false } })
    Vue.prototype.$adminLocalizationEnabled = () => state.enabled
    Vue.prototype.$adminLocale = () => state.locale
    Vue.prototype.$setAdminLocale = locale => {
      admin.setLocale(locale)
      state.locale = admin.locale
    }
    Vue.prototype.$adminT = (key, source, params) => {
      // Reading observable state subscribes every render/computed caller to locale changes.
      state.locale
      state.enabled

      return admin.t(key, source, params)
    }
    Vue.component('admin-language-selector', AdminLanguageSelector)
    // Evaluated once per page load; failed/older backends retain the original UI.
    Promise.resolve().then(loadFlags).then(flags => {
      state.enabled = Boolean(flags && flags['admin-localization'] === true)
      admin.setEnabled(state.enabled)
      state.locale = admin.locale
    }).catch(() => { /* Keep localization OFF if the flag cannot be loaded. */ })
  },
}
